import { useCallback, useState } from 'react'

import { useFirstRenderContext } from '@tribeplatform/react-components/common/ssr'
import { CookieConsentPermissions } from '@tribeplatform/react-sdk/types'
import { Container } from '@tribeplatform/react-ui-kit/Layout'
import { Portal } from '@tribeplatform/react-ui-kit/Portal'

import { CookieConsentPopUp } from './CookieConsentPopUp.js'
import { CookieConsentPreferencesModal } from './CookieConsentPreferencesModal.js'
import { useCookieConsent } from './CookieConsentProvider.js'
import {
  getAnalyticsCookiePermissions,
  getMarketingCookiePermissions,
} from './utils/cookie.js'

export const CookieConsent = () => {
  const { isFirstRender } = useFirstRenderContext()
  const [isPopUpOpen, setIsPopUpOpen] = useState(true)
  const [isPreferencesModalOpen, setIsPreferencesModalOpen] = useState(false)
  const { setCookieConsent, isAwaitingConsent } = useCookieConsent()

  const onAcceptAll = useCallback(() => {
    const newPermissions: CookieConsentPermissions[] = [
      getAnalyticsCookiePermissions(),
      getMarketingCookiePermissions(),
    ]

    setIsPopUpOpen(false)
    setIsPreferencesModalOpen(false)
    setCookieConsent(newPermissions)
  }, [setCookieConsent])

  if (isFirstRender || !isAwaitingConsent) {
    return null
  }

  return (
    <>
      {isPopUpOpen && (
        <Portal>
          <Container
            size="full"
            padding={{ size: 'md', disableOnMobile: true }}
            containerProps={{
              className: 'fixed inset-x-0 bottom-0',
            }}
          >
            <Container size="xl">
              <CookieConsentPopUp
                onManage={() => setIsPreferencesModalOpen(true)}
                onAcceptAll={onAcceptAll}
              />
            </Container>
          </Container>
        </Portal>
      )}
      {isPreferencesModalOpen && (
        <CookieConsentPreferencesModal
          isOpen={isPreferencesModalOpen}
          onClose={() => setIsPreferencesModalOpen(false)}
        />
      )}
    </>
  )
}
